import { useTranslation } from 'react-i18next';
import { LanguageSelector } from '@/presentation/components/common/LanguageSelector';
import { ThemeToggle } from '@/presentation/components/common/ThemeToggle';
import { useAuth } from '@/presentation/contexts/useAuth';

/** Shell mínimo cuando hay clínicas pero ningún permiso de menú (sin rol o rol vacío). */
export function NoPermissionsShell() {
  const { t } = useTranslation();
  const { logout } = useAuth();

  return (
    <div
      data-testid="no-permissions-shell"
      className="flex h-full min-h-0 flex-col bg-slate-100 font-sans text-slate-900 dark:bg-gray-950 dark:text-white"
    >
      <header className="panel-shell-header z-20 flex shrink-0 items-center justify-between gap-2 border-b border-slate-200/70 bg-white/90 px-3 backdrop-blur-md dark:border-gray-800 dark:bg-gray-900/90 sm:px-4">
        <img
          src="/assets/images/coofit-logo.png"
          alt="Coofit"
          className="h-6 w-auto shrink-0 object-contain sm:h-7"
        />
        <div className="flex shrink-0 items-center gap-1.5 sm:gap-2">
          <button
            type="button"
            onClick={logout}
            className="rounded-xl border border-slate-200 px-2.5 py-2 text-xs font-semibold text-slate-700 transition hover:bg-slate-100 dark:border-gray-700 dark:text-slate-200 dark:hover:bg-gray-800 sm:px-3"
          >
            {t('auth.logout')}
          </button>
          <LanguageSelector menuPlacement="down" />
          <ThemeToggle />
        </div>
      </header>

      <main className="flex min-h-0 flex-1 items-center justify-center p-4 sm:p-6">
        <div
          data-testid="no-permissions-empty"
          role="alert"
          aria-labelledby="no-permissions-title"
          aria-describedby="no-permissions-description"
          className="w-full max-w-md rounded-2xl border border-slate-200/80 bg-white p-5 text-center shadow-sm dark:border-gray-700 dark:bg-slate-900 sm:p-6"
        >
          <h1 id="no-permissions-title" className="text-lg font-bold text-slate-900 dark:text-white sm:text-xl">
            {t('scope.noPermissions.title')}
          </h1>
          <p
            id="no-permissions-description"
            className="mt-3 text-sm leading-relaxed text-slate-600 dark:text-slate-300"
          >
            {t('scope.noPermissions.message')}
          </p>
          <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">{t('scope.noPermissions.contact')}</p>
        </div>
      </main>
    </div>
  );
}
